import React from 'react';
import { TextField } from '@mui/material';
import { ControllerRenderProps, FieldErrors } from 'react-hook-form';
import {
  EditProjectFormData,
  useEditProjectDialogStore,
} from '../edit-project.store';
import { is } from '@client/helpers/dom.guards';
import { useComponentUUID } from '@client/hooks/use-utils.hooks';

interface NameInputProps extends React.ComponentProps<typeof TextField> {
  field: ControllerRenderProps<EditProjectFormData, 'name'>;
  errors: FieldErrors<EditProjectFormData>;
}

const NameInput = ({ field, errors, ...props }: NameInputProps) => {
  const focusField = useEditProjectDialogStore((s) => s.focusField);
  const active = focusField === 'name';
  // A fresh name each mount, plus autoComplete="off", stops the browser from
  // matching values previously typed into this field. Both stay after {...props}
  // so a caller cannot turn suggestions back on.
  const generatedName = useComponentUUID();

  return (
    <TextField
      {...field}
      label="Name"
      size="small"
      required
      autoFocus={active}
      onFocus={(e) => active && is.Input(e.target) && e.target.select?.()}
      fullWidth
      error={!!errors.name}
      helperText={errors.name?.message}
      {...props}
      autoComplete="off"
      name={props.name ?? generatedName}
    />
  );
};

export default NameInput;
